export default __webpack_public_path__ + "static/media/help-desk-7.d70b0e8a.png";